import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"
import "choices.js/public/assets/styles/choices.min.css"
import tippy from "tippy.js"
import "tippy.js/dist/tippy.css"

// Controller for enhanced remakes dashboard
// Initializes Choices.js multi-selects and Tippy.js tooltips
export default class extends Controller {
  connect() {
    this.initChoices()
    this.initTooltips()
  }

  initChoices() {
    ['offices', 'departments', 'faults', 'products', 'reasons'].forEach(name => {
      const elem = this.element.querySelector(`[name='${name}[]']`)
      if (elem && !elem._choices) {
        const instance = new Choices(elem, {
          removeItems: true,
          removeItemButton: true,
        })
        elem._choices = instance
      }
    })
  }

  initTooltips() {
    this.element.querySelectorAll('.tooltip').forEach(elem => {
      if (!elem._tippy) {
        tippy(elem, {
          placement: 'right',
          content: elem.getAttribute('data-tooltip'),
          maxWidth: 500,
        })
      }
    })
  }
}
